import type { Tournament } from '@shootout-comps/types';
import type { TournamentSettingsInput } from './TournamentContext';

export interface CompleteTournamentCreationParams {
  createTournament: (paymentToken?: string) => Promise<Tournament>;
  updateName: (id: string, name: string) => Promise<void>;
  updateSettings: (id: string, settings: TournamentSettingsInput) => Promise<void>;
  paymentToken?: string;
  name: string;
  settings: TournamentSettingsInput;
}

// The post-payment tournament setup sequence — shared because both web (Stripe Checkout
// redirect return) and mobile (Stripe PaymentSheet success) converge on the same opaque
// paymentToken contract and need to do exactly this afterward.
export async function completeTournamentCreation(params: CompleteTournamentCreationParams): Promise<Tournament> {
  const { createTournament, updateName, updateSettings, paymentToken, name, settings } = params;
  const t = await createTournament(paymentToken);
  await updateName(t._id, name);
  await updateSettings(t._id, settings);
  // Caller only needs the id (name/settings updates land in context's own `tournament`
  // state via updateName/updateSettings's setTournament calls) — no redundant re-fetch.
  return t;
}
